import { FiGlobe, FiHome, FiTrendingUp, FiUserPlus } from "react-icons/fi";
import { Link } from "react-router-dom";
import home from "../assets/home.png";
import investhome from "../assets/investhome.png";
import Benefits from "./cards/Benefits";
import Sequence from "./cards/Sequence";
import "./Home.css";
import {
  FiBriefcase,
  FiDollarSign,
  FiEye,
  FiShuffle,
  FiArrowRight,
} from "react-icons/fi";

function Home() {
  return (
    <div>
      <div className="landing">
        {/* Section: Hero */}

        <div className="container pt-5 pb-5">
          <div className="row ">
            <div className="col-md-6 mt-auto mb-auto pe-md-4 title-holder text-center text-md-start">
              <h1
                className="fw-bold display-5"
                style={{ lineHeight: 1.2, marginBottom: "1.5rem" }}
              >
                Real Estate Investing
                <br />
                Made Simple and Accessible
              </h1>

              <p
                className="text-muted lead mt-4"
                style={{ fontSize: "1.1rem", lineHeight: 1.6 }}
              >
                Start building generational wealth by investing in premium
                properties with as little as ₦50,000. Enjoy passive income
                through rental yields and capital appreciation — all without the
                hassle of property management.
              </p>

              <div className="mt-4 d-flex justify-content-center justify-content-md-start">
                <a
                  href="https://app.investify.africa/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <button
                    className="btn btn-success"
                    style={{
                      padding: "14px 40px",
                      fontSize: "1rem",
                      fontWeight: "600",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      border: "none",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 12px rgba(40, 167, 69, 0.3)",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 6px 16px rgba(40, 167, 69, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 4px 12px rgba(40, 167, 69, 0.3)";
                    }}
                  >
                    Get Started Now <FiArrowRight size={18} />
                  </button>
                </a>
              </div>
            </div>

            <div className="text-center col-md-6 mt-4 mt-md-0">
              <img
                src={home}
                alt="Investify App"
                className="img-fluid"
                style={{ maxHeight: 500 }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section: How does it work */}

      <div className="container text-center mb-5" style={{ marginTop: 100 }}>
        <h2 className="fw-bold mb-2" style={{ fontSize: "2.5rem" }}>
          How Investify Works
        </h2>
        <p className="text-muted mb-5" style={{ fontSize: "1.1rem" }}>
          Get started in three simple steps — no experience needed.
        </p>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4 col-sm-12 p-4">
              <Sequence
                icon={<FiUserPlus size={24} />}
                title="Create Your Account"
                para="Sign up in minutes with your email. Verify your identity and start exploring investment opportunities immediately — completely free."
              />
            </div>
            <div className="col-md-4 col-sm-12 p-4">
              <Sequence
                icon={<FiGlobe />}
                title="Browse & Select Properties"
                para="Explore curated real estate projects across Nigeria. Review detailed reports, location insights, and projected returns for each property."
              />
            </div>
            <div className="col-md-4 col-sm-12 p-4">
              <Sequence
                icon={<FiTrendingUp />}
                title="Invest & Earn Returns"
                para="Buy property shares starting at ₦50,000. Watch your investment grow through rental income and property appreciation."
              />
            </div>
          </div>
        </div>
        <Link to="/how-it-works">
          <div>
            <button
              className="btn btn-outline-success me-2 p-3"
              style={{ borderRadius: 8, fontWeight: 600, marginTop: "2rem" }}
            >
              See Detailed Walkthrough
            </button>
          </div>
        </Link>
      </div>

      {/* The 4 types of Real Estate */}
      <div className="landing3 benefit-block" style={{ marginTop: 100 }}>
        <div className="container pt-3 pb-4">
          <div className="new-hold">
            <h2 className="fw-bold mb-3" style={{ fontSize: "2.5rem" }}>
              Diversify Your Portfolio Across Multiple Property Types
            </h2>
            <p className="text-muted" style={{ fontSize: "1.1rem" }}>
              Every investor is different. Choose from residential, commercial,
              industrial, or land investments. Each offers unique growth
              potential and income streams.
            </p>
          </div>

          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 col-sm-12 p-4">
                <Benefits
                  icon={<FiHome />}
                  title="Residential Real Estate"
                  para="Invest in homes, apartments, and residential complexes generating steady rental income. Perfect for passive cash flow in growing communities."
                />
              </div>
              <div className="col-md-6 col-sm-12 p-4">
                <Benefits
                  icon={<FiHome />}
                  title="Land Investments"
                  para="Own undeveloped land positioned for appreciation. Benefit from location growth and future development potential with minimal maintenance."
                />
              </div>
              <div className="col-md-6 col-sm-12 p-4">
                <Benefits
                  icon={<FiHome />}
                  title="Industrial Properties"
                  para="Secure long-term leases with factories, warehouses, and logistics centers. Enjoy stable, higher-yielding returns from industrial tenants."
                />
              </div>
              <div className="col-md-6 col-sm-12 p-4">
                <Benefits
                  icon={<FiHome />}
                  title="Commercial Real Estate"
                  para="Partner in retail spaces, offices, and service properties. Tap into high-demand commercial sectors with premium rental rates."
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Info */}

      {/* Investment Journey */}
      <div className="container pt-5 mb-5" style={{ marginTop: 100 }}>
        <div className="row">
          <div className="col-md-6 text-center mb-5">
            <img
              src={investhome}
              alt="Investify Mobile"
              className="img-fluid"
              style={{ height: 600 }}
            />
          </div>
          <div className="col-md-6 mb-auto mt-auto text-center">
            <h2
              className="fw-bold"
              style={{ fontSize: "2.2rem", lineHeight: 1.3 }}
            >
              Start Your Real Estate <br />
              <span
                className="bg-success text-white px-4 py-2 rounded"
                style={{
                  lineHeight: 2.0,
                  display: "inline-block",
                  marginTop: "1rem",
                }}
              >
                Journey with Just ₦50,000
              </span>
            </h2>
            <p
              className="text-muted mt-4"
              style={{ fontSize: "1.1rem", lineHeight: 1.6 }}
            >
              No need for millions of naira to build wealth through real estate.
              Investify makes premium property investment accessible to
              everyone. Start small, think big, and let your money compound over
              time.
            </p>

            <div className="mt-5">
              <a
                href="https://app.investify.africa/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <button
                  className="btn btn-success"
                  style={{
                    padding: "14px 40px",
                    fontSize: "1rem",
                    fontWeight: "600",
                    borderRadius: "8px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    border: "none",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 12px rgba(40, 167, 69, 0.3)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow =
                      "0 6px 16px rgba(40, 167, 69, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 4px 12px rgba(40, 167, 69, 0.3)";
                  }}
                >
                  Start Investing Now <FiArrowRight size={18} />
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="landing3 benefit-block">
        <div
          className="container pt-5 pb-5"
          // style={{ marginTop: 50 }}
        >
          <div className="new-hold">
            <h2 className="fw-bold mb-3" style={{ fontSize: "2.5rem" }}>
              Why Investors Choose Investify
            </h2>
            <p className="text-muted" style={{ fontSize: "1.1rem" }}>
              We've removed the barriers to real estate investment. No agents,
              no bureaucracy — just smart, transparent investing.
            </p>
          </div>

          <div className="row">
            <div className="col-md-4 p-3">
              <Benefits
                icon={<FiUserPlus />}
                title="Zero Entry Barriers"
                para="Create your account free and instantly. Start investing with as little as ₦50,000 — no hidden fees, minimum deposits, or gatekeeping."
              />
            </div>
            <div className="col-md-4 p-3">
              <Benefits
                icon={<FiBriefcase />}
                title="Hands-Free Property Management"
                para="We handle tenant screening, rent collection, maintenance, and compliance. Your job? Just watch your investments grow."
              />
            </div>
            <div className="col-md-4 p-3">
              <Benefits
                icon={<FiTrendingUp />}
                title="Real Wealth Building"
                para="Real estate appreciation + rental income = sustainable wealth. Protect your money from inflation while earning active monthly returns."
              />
            </div>
            <div className="col-md-4 p-3">
              <Benefits
                icon={<FiDollarSign />}
                title="Instant Liquidity"
                para="Need your money back? Sell your shares anytime through your dashboard. No waiting for a buyer, no real estate agent delays."
              />
            </div>
            <div className="col-md-4 p-3">
              <Benefits
                icon={<FiEye />}
                title="Complete Transparency"
                para="Access property documents, financial reports, and performance metrics anytime. Know exactly where your money is and how it's growing."
              />
            </div>
            <div className="col-md-4 p-3">
              <Benefits
                icon={<FiShuffle />}
                title="Smart Diversification"
                para="Spread investments across multiple properties, types, and locations. Reduce risk and stabilize returns across your portfolio."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
